import $ from "jquery";
import "jquery/dist/jquery";
import "bootstrap/js/dist/util";
import "bootstrap/js/dist/carousel";
import "bootstrap/js/dist/tab";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/modal";
import { initMenu } from "./components/Menu";
import { initToggle } from "./components/Toggle";
import { SearchBox } from "./components/SearchBox";

import "./components/ContrastSwitch";
import "./components/AreasApi";
import "./components/FontSizer";
import "./components/Carousel";
import "./components/FixedHeader";
import "./components/Swipebox";
import "./components/StyledSelect";
import { SubmenuToggle } from "./components/MobileSubmenu";
import { LetterFilter } from "./components/LetterFilter";
import { LetterFilterDictionary } from "./components/LetterFilterDictionary";
import { ScrollingButtons } from "./components/ScrollingButtons";
import { ScrollingButtonsDictionary } from "./components/ScrollingButtonsDictionary";

import { PlayVideo } from "./components/PlayVideo";
import "./components/Megamenu";
import "./components/SmoothScroll";
import "./components/TextareaAdaptiveHeight";
import "./components/SamplePlayer";
import "./components/Faq";
import "./components/Tippy";
import "./components/MatchHeight";
import "./components/readMoreJS";

$("#dicrionary").keypress(function(event) {
  if (event.keyCode == 13) {
    event.preventDefault();
    return false;
  }
});
import { SearchWords } from "./components/SearchWords";
import { SearchDictionary } from "./components/SearchDictionary";

initMenu(".js-menu-trigger");
initToggle(".js-toggle");
initToggle(".js-search-toggle", {
  disableScroll: true
});
$('input[type="number"]').on("keyup", function() {
  if ($(this).val() > $(this).attr("max") * 1) {
    $(this).val($(this).attr("max"));
  }
});
const search = document.querySelectorAll(".js-search-box");
search.forEach(element => {
  SearchBox(element, element.dataset.target);
});
const searchDictionary = document.querySelectorAll(".js-search-box2");
searchDictionary.forEach(element => {
  SearchDictionary(element, element.dataset.target);
});

$(function() {
  $("input[type='number']").prop("min", 1);
  $("input[type='number']").prop("max", 99);

  if ($(".faqs__item").length > 0) {
    $(".collapse").on("shown.bs.collapse", function(e) {
      var $panel = $(this).closest(".faqs__item");
      $("html,body").animate(
        {
          scrollTop: $panel.offset().top - 150
        },
        100
      );
    });
  }
  if ($(".timeline__item__body").length > 0) {
    $(".collapse").on("shown.bs.collapse", function(e) {
      var $panel = $(this).closest(".timeline__item__body");
      $("html,body").animate(
        {
          scrollTop: $panel.offset().top - 150
        },
        100
      );
    });
  }

  $("#pricing-table").addClass("custom-height");
  $(".cicrcle-button").on("click", function() {
    $("#pricing-table").toggleClass("custom-height", 500);
  });
});
SubmenuToggle();
LetterFilter();
LetterFilterDictionary();
SearchWords();
ScrollingButtons(".js-pricing-nav", ".js-pricing-nav-arrow");
ScrollingButtonsDictionary(".js-searching-nav", ".js-searching-nav-arrow");
PlayVideo();



$( "#pagecontent .blog-item .heading" ).each(function() {
  if ($(this).has('h4').length) {
    $(this).addClass('heading--black');
  }
  if ($(this).has('h5').length) {
    $(this).addClass('heading--black');
  }
  if ($(this).has('h6').length) {
    $(this).addClass('heading--black');
  }
});

$( "#pagecontent .pagewrap__content .heading" ).each(function() {
  if ($(this).has('h4').length) {
    $(this).addClass('heading--black');
  }
});